<ion-header class="gub-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <!-- <ion-menu-button (click)='closeMenu()'></ion-menu-button> -->
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
    <ion-card class="no-shadow black-text">
        <h1 class="title-button" expand="full" color="success">{{ 'questionnaireoutput.thank_you' | translate }}</h1>  

        <div>
          <div class="ion-padding big-thumbs icon-box gub-italic home-box message-box" >
            <app-messagebubble [text]="response.output.response"></app-messagebubble>
            <p class="pre_wrap" [innerHTML]="response.output.response"></p>
          </div>
        </div>
        <ion-row *ngIf="response.output.action">
            <!-- Phone action button -->
            <ion-col *ngIf="response.output.action.code == 'phone' && validPhone()" class="ion-text-center" size="12">
                <ion-button (click)="call()" [disabled]="button_disabled" size="large" color="success">
                  <ion-icon name="call"></ion-icon>
                </ion-button>
            </ion-col>

            <!-- Standard page action (handle page navigation first, including listing) -->
            <ion-col *ngIf="response.output.action.page && !hasLinkedWebform()" class="ion-text-center" size="12">
                <ion-button (click)='page()' [disabled]="button_disabled" expand="block" color="primary" [innerHTML]="response.output.action.name"></ion-button>
            </ion-col>

            <!-- When there is a linked webform (but no page action), show two buttons: one to continue without completing the form, and one to go to the form. -->
            <!-- Action with linked webform - show choice buttons -->
            <ion-col *ngIf="hasLinkedWebform()" class="ion-text-center" size="12">
                <!-- Debug wrapper: onContinueClicked will log the event and current state before delegating -->
                <ion-button (click)="onContinueClicked($event)" [disabled]="button_disabled" expand="block" color="primary">
                    Continue without completing form
                </ion-button>
            </ion-col>
            <ion-col *ngIf="hasLinkedWebform()" class="ion-text-center" size="12">
                <ion-button (click)="goToWebform()" [disabled]="button_disabled" expand="block" color="success">
                    Complete form
                </ion-button>
            </ion-col>

            <!-- Show inbox button -->
            <ion-col *ngIf="response.output.action.showinbox" class="ion-text-center" size="12">
                <ion-button (click)="gotoinbox()" [disabled]="button_disabled" expand="block" color="primary">{{ 'inbox.title' | translate }}</ion-button>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="!response.output.action || (response.output.action  && response.output.action.code == '')">
          <ion-col class="ion-text-center" size="12">
            <ion-button (click)='ok()' [disabled]="button_disabled" expand="block" color="success">
              <ion-spinner *ngIf="button_disabled" name="crescent"></ion-spinner>
              <span *ngIf="!button_disabled">{{ 'common.ok' | translate }}</span>
            </ion-button>
          </ion-col>
        </ion-row>
    </ion-card>
</ion-content>